import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { ListFilter, createDateFilter, createMultiSelectFilter, createSelectFilter } from '../../../../../Components/ListFilter';

interface IProps {
  setFilter: (field: string, values: string[] | { min?: Date; max?: Date } | undefined) => void;
  filters: any;
}

export const ObservationFilter: FC<IProps> = ({ filters, setFilter }) => {
  const { formatMessage } = useIntl();

  const dateFilter = createDateFilter(
    'EffectiveFrom',
    formatMessage({ id: 'utils.filters.comformities.from' }),
    formatMessage({ id: 'utils.filters.comformities.to' }),
  );

  const OpenOption = { value: 1, label: formatMessage({ id: 'utils.filters.status.open' }) };
  const ClosedOption = { value: 3, label: formatMessage({ id: 'utils.filters.status.closed' }) };

  const statusFilter = createSelectFilter(
    'status',
    formatMessage({ id: 'utils.filters.status' }),
    [OpenOption, ClosedOption],
    (option) => option.value.toString(),
    OpenOption,
    filters?.status,
  );

  const deficiencyOption = { value: "deficiency", label: formatMessage({ id: 'law-portal.compliance.question.compliance.deficiency.label' }) };
  const observationsOption = { value: "no", label: formatMessage({ id: 'law-portal.compliance.question.compliance.no.label' }) };
  const nonConformitiesFilter = createMultiSelectFilter(
    'nonconformities',
    formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.observations' }),
    [deficiencyOption, observationsOption],
    (option) => option.value.toString(),
    undefined,
    filters?.nonconformities,
  );


  return <ListFilter filters={[dateFilter, nonConformitiesFilter, statusFilter]} setFilter={setFilter} />;
};
